import { useState } from 'react';
import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '250px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '250px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const PonBoxContainerEdit = ({toggleVisibilityPonBox, isVisiblePonBox, ponboxData, handleChangePonBox, selectedPonBox, commentPonBox, commentTextAreaRefPonBox,
      handleCommentChangePonBox, togglePonBoxMarker, ponBoxMarker, ponBoxConstructSave, dividerData,selectedDividerOption, handleChangeDividerSelect,polishingData, selectedPolishing, 
      handleChangePolishing, handleAdapterChange, adapterCount, handlePigtailChange, pigtailCount }) => {

      const options = dividerData.map(divider => ({
        value: divider.id,  
        label: divider.model,
        group: divider.polishingId === 1 ? "UPC" : "APC", 
      }));
    
      // Группировка опций
      const groupedOptions = [
        {
          label: "UPC",
          options: options.filter(option => option.group === "UPC"),
        },
        {
          label: "APC",
          options: options.filter(option => option.group === "APC"),
        },
      ];

     

  return (
    <React.Fragment>
      <button onClick={toggleVisibilityPonBox} className={isVisiblePonBox ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisiblePonBox ? 'Пон-бокс: скрыть' : 'Пон-бокс: показать'}
      </button>
      {isVisiblePonBox && (
        <div className='divСommunicationsDrawer'>
       
           <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
          
          <label className='textTitleDrawer'>Пон-бокс</label>
          <hr className="horizontalLineDrawer" />
          <div>
           <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangePonBox} value={selectedPonBox}>
              <option value="null">Выберите пон-бокс</option>
              {ponboxData.map(fob => (
                <option key={fob.id} value={fob.id}>{fob.name}</option>
              ))}
            </select>
            <Select
              className="selectSearchDrawer"
              options={groupedOptions}
              value={selectedDividerOption} 
              styles={customStyles}
              onChange={handleChangeDividerSelect}
              placeholder={"Выберите делитель"}
              isClearable
            />
            <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />          

          </div>
           <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
                 <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangePolishing} value={selectedPolishing}>
                  <option value="null">Выберите полировку</option>
                  {polishingData.map(polishing => (
                    <option key={polishing.id} value={polishing.id}>{polishing.type}</option>
                  ))}
                 </select>
                  <br/>
                  <>
                    <label className='textTitleDrawer'>Pigtail: </label>
                        
                    <input
                      type='number'
                      min={0}
                      className='textInput2EditingModal'
                      value={pigtailCount} 
                      onChange={handlePigtailChange} 
                    /> 
                    <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label> 
                    </>
                    <br/>
                  <>
                    <label className='textTitleDrawer'>Adapter: </label>
                        
                    <input
                      type='number'
                      min={0}
                      className='textInput2EditingModal'
                      value={adapterCount} 
                      onChange={handleAdapterChange} 
                    />  
                    <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label> 
                    </>
              </div>
          <div >

            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentPonBox}
              ref={commentTextAreaRefPonBox}
              onChange={handleCommentChangePonBox}
            />
            <button onClick={togglePonBoxMarker} className={ponBoxMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {ponBoxMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={ponBoxConstructSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default PonBoxContainerEdit;